import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import Api from '@/api/api.js'
// import Config from '../config'
import Buefy from 'buefy'
import moment from 'moment-timezone'
import Swal from 'sweetalert2'

import AllIosIcon from 'vue-ionicons/dist/ionicons-ios.js'
import 'buefy/dist/buefy.css'
import Paginate from 'vuejs-paginate'
require('vue-ionicons/ionicons.css')

Vue.config.productionTip = false
Vue.prototype.$axios = Axios
Vue.prototype.$api = Api
// Vue.prototype.$axios.defaults.baseURL = Config.serverUrl
// Vue.prototype.$config = Config
Vue.prototype.$swal = Swal

Vue.prototype.$moment = moment
Vue.prototype.$moment.tz.setDefault('Asia/Yangon')

Vue.component('paginate', Paginate)

Vue.use(AllIosIcon)
Vue.use(Buefy)

fetch(process.env.BASE_URL + 'config.json').then(res => {
	res.json().then(Config => {
		console.log(Config)

		Vue.prototype.$axios.defaults.baseURL = Config.serverUrl
		Vue.prototype.$config = Config

		new Vue({
			router,
			store,
			render: h => h(App)
		}).$mount('#app')
	})
})
